import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';
import BodyControl from "../../components/body";
import {WINDOW, DOCUMENT} from "../../constants/environment";

/**
 * MyMazda
 */
class MyMazda extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    logoutStatus: PropTypes.shape({
      pcText: PropTypes.string,
      mbText: PropTypes.string,
      pcIconSrc: PropTypes.string,
      mbIconSrc: PropTypes.string,
    }),
    loginStatus: PropTypes.shape({
      pcText: PropTypes.string,
      mbText: PropTypes.string,
      pcIconSrc: PropTypes.string,
      mbIconSrc: PropTypes.string,
    }),
    loginLink: PropTypes.shape({
      pcText: PropTypes.string,
      mbText: PropTypes.string,
      pcIconSrc: PropTypes.string,
      mbIconSrc: PropTypes.string,
    }),
    registrationLink: PropTypes.shape({
      pcText: PropTypes.string,
      mbText: PropTypes.string,
      pcIconSrc: PropTypes.string,
      mbIconSrc: PropTypes.string,
      href: PropTypes.string,
      target: PropTypes.string,
    }),
    myMazdaLink: PropTypes.shape({
      hideName: PropTypes.bool,
      pcText: PropTypes.string,
      mbText: PropTypes.string,
      pcIconSrc: PropTypes.string,
      mbIconSrc: PropTypes.string,
      href: PropTypes.string,
      target: PropTypes.string,
    }),
    logoutLink: PropTypes.shape({
      pcText: PropTypes.string,
      mbText: PropTypes.string,
      pcIconSrc: PropTypes.string,
      mbIconSrc: PropTypes.string,
    }),
    onOpened: PropTypes.func,
    onClosed: PropTypes.func,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    logoutStatus: null,
    loginStatus: null,
    loginLink: null,
    registrationLink: null,
    myMazdaLink: null,
    logoutLink: null,
    onOpened: null,
    onClosed: null,
  };

  constructor(props) {
    super();
    this.props = props;
    this.state = {
      mounted: false,
      login: false,
      uid: null,
      opened: false,
      // name: null,
    };
    //
    this.hostname = null;
    this.href = null;
    if (WINDOW && WINDOW.location && WINDOW.location.hostname && WINDOW.location.href) {
      this.hostname = WINDOW.location.hostname || null;
      this.href = WINDOW.location.href || null;
    }
  };

  componentDidMount() {
    this.setState({
      mounted: true,
    })
    // ユーザID取得
    const uid = this.getUserId();
    if (uid && uid !== '') {
      // ログイン
      this.setState({
        uid: uid,
        login: true,
      })
      // if (!this.props.myMazdaLink.hideName) {
      //   // MyMazda Webログインユーザー氏名取得
      //   this.apiAccessLoginUserName(uid).then((value)=> {
      //     // ログイン
      //     this.setState({
      //       name: value,
      //     })
      //   });
      // }
    } else {
      // ログアウト
      this.setState({
        uid: null,
        login: false,
      })
    }
  };

  componentWillUnmount() {
    this.setState({
      mounted: false,
    })
  };

  render() {

    // ログインステータス
    const renderStatus = ()=> {
      if (this.state.login) {
        // 既ログイン
        return (
          <a className={'MyMazda__link' + this.getIsEmptyLinksClassPc() + this.getIsEmptyLinksClassMb() + this.getIsEmptyTextClass(this.props.loginStatus.pcText, this.props.loginStatus.mbText) + this.getIsEmptyIconClass(this.props.loginStatus.pcIconSrc, this.props.loginStatus.mbIconSrc)} href="#" onClick={(e)=> {
            this.handleClick(e);
          }}>
            <span>{this.getText(this.props.loginStatus.pcText, this.props.loginStatus.mbText)}</span>
            <span>{this.getIcon('MyMazda__icon', this.props.loginStatus.pcIconSrc, this.props.loginStatus.mbIconSrc)}</span>
          </a>
        )
      } else {
        // 未ログイン
        return (
          <a className={'MyMazda__link' + this.getIsEmptyLinksClassPc() + this.getIsEmptyLinksClassMb() + this.getIsEmptyTextClass(this.props.logoutStatus.pcText, this.props.logoutStatus.mbText) + this.getIsEmptyIconClass(this.props.logoutStatus.pcIconSrc, this.props.logoutStatus.mbIconSrc)} href="#" onClick={(e)=> {
            this.handleClick(e);
          }}>
            <span>{this.getText(this.props.logoutStatus.pcText, this.props.logoutStatus.mbText)}</span>
            <span>{this.getIcon('MyMazda__icon', this.props.logoutStatus.pcIconSrc, this.props.logoutStatus.mbIconSrc)}</span>
          </a>
        )
      }
    }

    // ログインリンク
    const renderLoginLink = ()=> {
      if (!this.state.login) {
        // 未ログイン
        return (
          <li className={this.getIsEmptyTextClass(this.props.loginLink.pcText, this.props.loginLink.mbText) + this.getIsEmptyIconClass(this.props.loginLink.pcIconSrc, this.props.loginLink.mbIconSrc)}>
            <a className={'MyMazda__link2' + this.getIsEmptyTextClass(this.props.loginLink.pcText, this.props.loginLink.mbText) + this.getIsEmptyIconClass(this.props.loginLink.pcIconSrc, this.props.loginLink.mbIconSrc)} href="#" onClick={(e)=> {
              e.preventDefault();
              //
              if (this.hostname && this.href) {
                let str;
                // if (0 <= String(this.hostname).indexOf('localhost') || 0 <= String(this.hostname).indexOf('dev.mazda.co.jp')) {
                // if (this.hostname && (0 <= String(this.hostname).indexOf('dev.mazda.co.jp') || 0 <= String(this.hostname).indexOf('dev-mazda-co-jp') || 0 <= String(this.hostname).indexOf('uat.mazda.co.jp') || 0 <= String(this.hostname).indexOf('uat-mazda-co-jp'))) {
                if (this.hostname && (0 <= String(this.hostname).indexOf('uat.mazda.co.jp') || 0 <= String(this.hostname).indexOf('dev.mazda.co.jp') || 0 <= String(this.hostname).indexOf('.test.mazda.jp'))) {
                  str = 'https://my-mazda-co-jp.test.mazda.jp/login';
                } else {
                  str = 'https://my.mazda.co.jp/login';
                }
                // str += '?target=' + encodeURIComponent(this.href);
                if (WINDOW && WINDOW.location && WINDOW.location.href) WINDOW.location.href = str;
              }
            }}>
              {this.getText(this.props.loginLink.pcText, this.props.loginLink.mbText)}
              {this.getIcon('MyMazda__icon2', this.props.loginLink.pcIconSrc, this.props.loginLink.mbIconSrc)}
            </a>
          </li>
        )
      }
      return null;
    }

    // 新規会員登録リンク
    const renderRegistrationLink = ()=> {
      if (!this.state.login) {
        // 未ログイン
        return (
          <li className={this.getIsEmptyTextClass(this.props.registrationLink.pcText, this.props.registrationLink.mbText) + this.getIsEmptyIconClass(this.props.registrationLink.pcIconSrc, this.props.registrationLink.mbIconSrc)}>
            <a className={'MyMazda__link2 MyMazda__link2--white' + this.getIsEmptyTextClass(this.props.registrationLink.pcText, this.props.registrationLink.mbText) + this.getIsEmptyIconClass(this.props.registrationLink.pcIconSrc, this.props.registrationLink.mbIconSrc)} href={this.props.registrationLink.href} target={this.getTarget(this.props.registrationLink.target)}>
              {this.getText(this.props.registrationLink.pcText, this.props.registrationLink.mbText)}
              {this.getIcon('MyMazda__icon2', this.props.registrationLink.pcIconSrc, this.props.registrationLink.mbIconSrc)}
            </a>
          </li>
        )
      }
      return null;
    }

    // MyMazdaリンク
    const renderMyMazdaLink = ()=> {
      if (this.state.login) {
        return (
          <li className={'MyMazda__list-item--my-mazda' + this.getIsHideNameClass() + this.getIsEmptyTextClass(this.props.myMazdaLink.pcText, this.props.myMazdaLink.mbText) + this.getIsEmptyIconClass(this.props.myMazdaLink.pcIconSrc, this.props.myMazdaLink.mbIconSrc)}>
            <a className={'MyMazda__link2 MyMazda__link2--white MyMazda__link2--my-mazda' + this.getIsHideNameClass() + this.getIsEmptyTextClass(this.props.myMazdaLink.pcText, this.props.myMazdaLink.mbText) + this.getIsEmptyIconClass(this.props.myMazdaLink.pcIconSrc, this.props.myMazdaLink.mbIconSrc)} href={this.props.myMazdaLink.href} target={this.getTarget(this.props.myMazdaLink.target)}>
              {this.getText(this.props.myMazdaLink.pcText, this.props.myMazdaLink.mbText, this.getName())}
              {this.getIcon('MyMazda__icon2', this.props.myMazdaLink.pcIconSrc, this.props.myMazdaLink.mbIconSrc)}
            </a>
          </li>
        )
      }
      return null;
    }

    // ログアウトリンク
    const renderLogoutLink = ()=> {
      if (this.state.login) {
        // 既ログイン
        return (
          <li className={this.getIsEmptyTextClass(this.props.logoutLink.pcText, this.props.logoutLink.mbText) + this.getIsEmptyIconClass(this.props.logoutLink.pcIconSrc, this.props.logoutLink.mbIconSrc)}>
            <a className={'MyMazda__link2 ' + this.getIsEmptyTextClass(this.props.logoutLink.pcText, this.props.logoutLink.mbText) + this.getIsEmptyIconClass(this.props.logoutLink.pcIconSrc, this.props.logoutLink.mbIconSrc)} href="#" onClick={(e)=> {
              e.preventDefault();
              //
              if (this.hostname && this.href) {
                let str;
                // if (0 <= String(this.hostname).indexOf('localhost') || 0 <= String(this.hostname).indexOf('dev.mazda.co.jp')) {
                // if (this.hostname && (0 <= String(this.hostname).indexOf('dev.mazda.co.jp') || 0 <= String(this.hostname).indexOf('dev-mazda-co-jp') || 0 <= String(this.hostname).indexOf('uat.mazda.co.jp') || 0 <= String(this.hostname).indexOf('uat-mazda-co-jp'))) {
                if (this.hostname && (0 <= String(this.hostname).indexOf('uat.mazda.co.jp') || 0 <= String(this.hostname).indexOf('dev.mazda.co.jp') || 0 <= String(this.hostname).indexOf('.test.mazda.jp'))) {
                  str = 'https://my-mazda-co-jp.test.mazda.jp/logout';
                } else {
                  str = 'https://my.mazda.co.jp/logout';
                }
                str += '?target=' + encodeURIComponent(this.href);
                if (this.state.uid && this.state.uid !== '') {
                  str += '&id=' + this.state.uid;
                }
                if (WINDOW && WINDOW.location && WINDOW.location.href) WINDOW.location.href = str;
              }
            }}>
              {this.getText(this.props.logoutLink.pcText, this.props.logoutLink.mbText)}
              {this.getIcon('MyMazda__icon2', this.props.logoutLink.pcIconSrc, this.props.logoutLink.mbIconSrc)}
            </a>
          </li>
        )
      }
      return null;
    }

    return (
      <Wrapper
        containerId={this.props.containerId}
        containerClass={this.props.containerClass}
      >
        <div className="MyMazda">
          {(()=> {
            if (this.state.opened) {
              return (
                <div className="MyMazda__bg" onClick={(e)=> {
                  this.handleClick(e);
                }}>&nbsp;</div>
              )
            } else {
              return null;
            }
          })()}
          {(()=> {
            if (this.state.mounted) {
              return (
                <div className={'MyMazda__status' + ((this.state.opened) ? ' hide' : '')}>
                  {renderStatus()}
                </div>
              )
            } else {
              return null;
            }
          })()}
          <div className={'MyMazda__container' + ((this.state.opened) ? ' opened' : '')}>
            <ul className="MyMazda__list">
              {renderLoginLink()}
              {renderRegistrationLink()}
              {renderMyMazdaLink()}
              {renderLogoutLink()}
            </ul>
          </div>
        </div>
      </Wrapper>
    )
  }

  // 閉じる
  close = ()=> {
    this.setState({
      opened: false,
    })
  }

  // 名前取得
  getName = ()=> {
    if (this.props.myMazdaName && this.props.myMazdaName !== '') {

      // 名前が41文字以上の場合は改行
      if (41 <= this.props.myMazdaName.length) {
        const name = this.props.myMazdaName;
        const a = name.slice(0, 40);
        const b = '|';
        const c = name.slice(40);
        return a + b + c + ' 様 ';
      }

      return this.props.myMazdaName + ' 様 ';
    }
    // if (this.state.name && this.state.name !== '') {
    //   return this.state.name + ' 様 '
    // }
    return '';
  }

  // テキスト取得
  getText = (pc, mb, name = '')=> {

    const getPcText = () => {
      if (pc !== null && pc !== '') {
        return (
          <span className="MyMazda__text-pc">{getBorderText(name + pc)}</span>
        );
      }
      if (name !== null && name !== '') {
        return (
          <span className="MyMazda__text-pc">{name}</span>
        );
      }
      return null;
    };

    const getMbText = () => {
      if (mb !== null && mb !== '') {
        return (
          <span className="MyMazda__text-mb">{getBorderText(name + mb)}</span>
        )
      } else {
        if (pc !== null && pc !== '') {
          return (
            <span className="MyMazda__text-mb">{getBorderText(name + pc)}</span>
          );
        }
      }
      if (name !== null && name !== '') {
        return (
          <span className="MyMazda__text-mb">{name}</span>
        );
      }
      return null;
    };

    const getBorderText = (val)=> {
      if (val.indexOf('|')) {
        const arr = val.split('|');
        return arr.map((val2, i)=> {
          if (i < arr.length - 1) {
            return (
              <React.Fragment key={i}>{val2}<br/></React.Fragment>
            );
          } else {
            return val2;
          }
        })
      } else {
        return val;
      }
    };

    return (
      <React.Fragment>
        {getPcText()}
        {getMbText()}
      </React.Fragment>
    )
  }

  // アイコン取得
  getIcon = (cls, pc, mb)=> {

    const getPcIcon = () => {
      if (pc !== null && pc !== '') {
        return (
          <img className={cls + ' MyMazda__icon-pc'} src={pc} alt=""/>
        );
      }
      return null;
    };

    const getMbIcon = () => {
      if (mb !== null && mb !== '') {
        return (
          <img className={cls + ' MyMazda__icon-mb'} src={mb} alt=""/>
        )
      } else {
        if (pc !== null && pc !== '') {
          return (
            <img className={cls + ' MyMazda__icon-mb'} src={pc} alt=""/>
          );
        }
      }
      return null;
    };

    return (
      <React.Fragment>
        {getPcIcon()}
        {getMbIcon()}
      </React.Fragment>
    )
  }

  // OPEN / CLOSE
  handleClick = (e) => {
    e.preventDefault();
    if (this.state.opened) {
      this.setState({
        opened: false,
      })
      // BODYのスクロール無効化を解除
      BodyControl.clearUnScroll();
      //
      if (this.props.onClosed) {
        this.props.onClosed();
      }
    } else {
      this.setState({
        opened: true,
      })
      // BODYのスクロール無効化
      BodyControl.setUnScrollMb();
      //
      if (this.props.onOpened) {
        this.props.onOpened();
      }
    }
  }

  // ユーザID取得
  getUserId = ()=> {
    if(!DOCUMENT || !DOCUMENT.cookie){
      return false;
    }
    const cookies = document.cookie;
    const arr = cookies.split(';');
    for(var c of arr){
      var arr2 = c.split('=');
      if(arr2[0].match(/\mmuid/)) {
        return arr2[1];
      }
    }
  }

  // ターゲット取得
  getTarget = (target)=> {
    if (target === 'External') {
      return '_blank';
    }
    return '_self';
  }

  // テキストの有無で非表示にするクラスを付与
  getIsEmptyTextClass = (pc, mb)=> {
    let arr = [];
    if (!pc || pc === '') {
      arr.push('MyMazda__no-text-pc');
    }
    if (!mb || mb === '') {
      if (!pc || pc === '') {
        arr.push('MyMazda__no-text-mb');
      }
    }
    return ' ' + arr.join(' ');
  }

  // アイコンの有無で余白を調整するクラスを付与
  getIsEmptyIconClass = (pc, mb)=> {
    let arr = [];
    if (!pc || pc === '') {
      arr.push('MyMazda__no-icon-pc');
    }
    if (!mb || mb === '') {
      if (!pc || pc === '') {
        arr.push('MyMazda__no-icon-mb');
      }
    }
    return ' ' + arr.join(' ');
  }

  // リンクの有無によってプルダウンメニューを非表示にするクラスを付与
  getIsEmptyLinksClassPc = ()=> {
    if (this.state.login) {
      if (
        (!this.props.myMazdaLink.pcText || this.props.myMazdaLink.pcText === '')
        && (!this.props.myMazdaLink.pcIconSrc || this.props.myMazdaLink.pcIconSrc === '')
        && (!this.props.logoutLink.pcText || this.props.logoutLink.pcText === '')
        && (!this.props.logoutLink.pcIconSrc || this.props.logoutLink.pcIconSrc === '')
      ) {
        return ' MyMazda__no-links-pc';
      }
    } else {
      if (
        (!this.props.registrationLink.pcText || this.props.registrationLink.pcText === '')
        && (!this.props.registrationLink.pcIconSrc || this.props.registrationLink.pcIconSrc === '')
        && (!this.props.loginLink.pcText || this.props.loginLink.pcText === '')
        && (!this.props.loginLink.pcIconSrc || this.props.loginLink.pcIconSrc === '')
      ) {
        return ' MyMazda__no-links-pc';
      }
    }
    return '';
  }

  // リンクの有無によってプルダウンメニューを非表示にするクラスを付与
  getIsEmptyLinksClassMb = ()=> {
    if (this.state.login) {
      if (
        (!this.props.myMazdaLink.mbText || this.props.myMazdaLink.mbText === '')
        && (!this.props.myMazdaLink.pcText || this.props.myMazdaLink.pcText === '')
        && (!this.props.myMazdaLink.mbIconSrc || this.props.myMazdaLink.mbIconSrc === '')
        && (!this.props.myMazdaLink.pcIconSrc || this.props.myMazdaLink.pcIconSrc === '')
        && (!this.props.logoutLink.mbText || this.props.logoutLink.mbText === '')
        && (!this.props.logoutLink.pcText || this.props.logoutLink.pcText === '')
        && (!this.props.logoutLink.mbIconSrc || this.props.logoutLink.mbIconSrc === '')
        && (!this.props.logoutLink.pcIconSrc || this.props.logoutLink.pcIconSrc === '')
      ) {
        return ' MyMazda__no-links-mb';
      }
    } else {
      if (
        (!this.props.registrationLink.mbText || this.props.registrationLink.mbText === '')
        && (!this.props.registrationLink.pcText || this.props.registrationLink.pcText === '')
        && (!this.props.registrationLink.mbIconSrc || this.props.registrationLink.mbIconSrc === '')
        && (!this.props.registrationLink.pcIconSrc || this.props.registrationLink.pcIconSrc === '')
        && (!this.props.loginLink.mbText || this.props.loginLink.mbText === '')
        && (!this.props.loginLink.pcText || this.props.loginLink.pcText === '')
        && (!this.props.loginLink.mbIconSrc || this.props.loginLink.mbIconSrc === '')
        && (!this.props.loginLink.pcIconSrc || this.props.loginLink.pcIconSrc === '')
      ) {
        return ' MyMazda__no-links-mb';
      }
    }
    return '';
  }

  // 名前を非表示に
  getIsHideNameClass = ()=> {
    if (this.props.myMazdaLink.hideName) {
      return ' MyMazda__hide-name';
    }
    return '';
  }

}
export default MyMazda;



// WEBPACK FOOTER //
// ./src/containers/my-mazda/index.jsx